export default function getIncludedItem(included, relationship) {
  if (typeof relationship === "undefined") return null
  return included.find(
    item => item.type === relationship?.type && item.id === relationship?.id
  )
}
